<template>
	<div>
		<div class="layoutMain" :class="comClass">
			<div class="content___3Paa8">
				<div class="top___1W42Y">
					<div class="header___1cl15">
						<div style="display: flex;align-items: center;">
							<img class="icon" src="@/assets/home/logo.png" alt="">
							<div class="title___3DxND">{{ $store.state.logoName }}</div>
						</div>
					</div>
				</div>
				<div>
					<AppMain></AppMain>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'layout1',
	components: {
		AppMain: () => import('.//appMain'),
	},
	data() {
		return {
			comClass: ''
		}
	},
	watch: {
		$route(to) {
			if (to.fullPath === '/loginIndex') {
				this.comClass = 'loginBg'
			} else {
				this.comClass = 'pwdBg'
			}
		}
	},
	mounted() {
		if (this.$route.path === '/loginIndex') {
			this.comClass = 'loginBg'
		} else {
			this.comClass = 'pwdBg'
		}
	},
	methods: {}
}
</script>

<style scoped>
.layoutMain {
	display: flex;
	flex-direction: column;
	height: 100vh;
	overflow: auto;
}

.loginBg {
	/* background: url('@/assets/img/loginbg.png') no-repeat !important; */
	background-image: url('@/assets/img/loginbg.png');
	/* 替换为实际的背景图片路径 */
	background-size: cover;
	/* 使背景图片覆盖整个容器，保持宽高比 */
	background-position: center;
	/* 背景图片居中 */
	background-repeat: no-repeat;
	/* 不重复背景图片 */
}

.pwdBg {
	background: #f0f2f5 !important;
}

.content___3Paa8 {
	padding: 32px 0 24px;
	display: flex;
	flex: 1 1;
	flex-flow: column;
}

.top___1W42Y {
	text-align: left;
}

.header___1cl15 {
	width: 1200px;
	height: 44px;
	margin: 0 auto;
	line-height: 44px;
}

.header___1cl15 .icon {
	height: 40px;
	margin-right: 10px;
}

.loginbox___DbLhH {
	display: flex;
	flex: 1 1;
	flex-flow: column;
	align-items: flex-end;
	justify-content: center;
}

.main___3ipCw {
	width: 400px;
	min-height: 326px;
	margin-right: 5%;
	padding: 20px 40px 15px;
	background: #fff;
	border-radius: 16px;
	box-shadow: 0 0 30px 0 #d2e1ee;
}

.title___3DxND {
	position: relative;
	top: 2px;
	color: rgba(0, 0, 0, .85);
	font-weight: 600;
	font-size: 35px;
	font-family: Avenir, "Helvetica Neue", Arial, Helvetica, sans-serif;
	line-height: 40px;
}
</style>